import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

type Result = ModelHookResult<{
	isMomentumBarEndorsementsEnabled: boolean;
	isMomentumBarCommentsSummaryEnabled: boolean;
	isMomentumBarMediaMentionsEnabled: boolean;
	isMomentumBarSharesCountEnabled: boolean;
	petitionPageMomentumBarExperiment: 'control' | 'enabled';
}>;

export const useIsMomentumBarEnabled = (): Result => {
	const {
		data: {
			featureConfigs: { petitionPageMomentumBar },
		},
	} = usePetitionDetailsPageData();

	const {
		data: { petitionPageMomentumBarExperiment },
	} = usePetitionDetailsPageUserData();

	const { submodules } = petitionPageMomentumBar;

	return {
		data: {
			isMomentumBarEndorsementsEnabled: !!submodules.endorsements?.enabled,
			isMomentumBarCommentsSummaryEnabled: !!submodules.commentsSummary?.enabled,
			isMomentumBarMediaMentionsEnabled: !!submodules.mediaMentions?.enabled,
			isMomentumBarSharesCountEnabled: !!submodules.sharesCount?.enabled,
			petitionPageMomentumBarExperiment,
		},
	};
};
